// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"716":"68b2a1a3","788":"859a4232"}[chunkId] + ".chunk.js";
};